import type { DataValue } from 'react-apollo';
import { graphql } from 'react-apollo';

import gql from 'graphql-tag';

import type { AdminUserPermissionsQuery } from './__generated__/AdminUserPermissionsQuery';

type Variables = {
  skip?: boolean;
  userId?: string | number | null;
};
type Data = AdminUserPermissionsQuery;

// We use an assembler resource vs. the `@naptime` directive since the information
// of a permission is encoded in the key of the `permissions` fields and not the value.
// At the time of writing, the `@naptime` directive will run the key values `_.camelCase`
// which is technically correct for graphql key naming conventions, but ruins the
// `wire format` for the permissions.
export const adminUserPermissionsQuery = gql`
  query AdminUserPermissionsQuery($skip: Boolean! = false) {
    AdminUserPermissionsV1Resource @skip(if: $skip) {
      my {
        elements {
          id
          permissions
        }
      }
    }
  }
`;

export type AdminUserPermissionsQueryProps = {
  adminUserPermissionsQuery?: {
    variables?: Variables;
    skip?: boolean;
  };
};

export type WithAdminUserPermissionsData = {
  adminUserPermissionsData: DataValue<Data, Variables>;
};

export const withAdminUserPermissions = graphql<AdminUserPermissionsQueryProps, Data, Variables>(
  adminUserPermissionsQuery,
  {
    options: ({ adminUserPermissionsQuery: { variables } = {} }) => {
      // Skip the initial query without the side-effects of the skip option, passing in skip props, etc.
      return { variables: { ...variables, skip: !variables?.userId }, notifyOnNetworkStatusChange: true };
    },
    name: 'adminUserPermissionsData',
  }
);

export default withAdminUserPermissions;
